import { useCallback } from "react";

import { useBooleanState, useMutationWithToaster } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

const deactivateUserFactory = () => {
  const query = `
    mutation deactivateUser($userId: ID!) {
      deactivateUser(userId: $userId) {
        successMessage
      }
    } 
  `;

  const resolver = ({ data: { deactivateUser } }) => {
    return { data: deactivateUser };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

function useDeactivateUser(deactivatedUserId, onDeactivated) {
  const [isSupportRequestShown, showIsSupportRequest] = useBooleanState(false);

  const [submit, { loading }] = useMutationWithToaster(deactivateUserFactory, {
    onDone: useCallback(
      (data) => {
        if (
          data.successMessage ===
          "Your deactivation request has been submitted."
        ) {
          showIsSupportRequest();
        } else {
          onDeactivated();
        }
      },
      [onDeactivated, showIsSupportRequest]
    ),
  });

  return {
    onSubmit: useCallback(async () => {
      await submit(
        { userId: deactivatedUserId },
        {
          successMsg: "User deactivated successfully",
          defaultErrorMsg: "Failed to deactivate user",
        }
      );
    }, [deactivatedUserId, submit]),
    loading: loading,
    showSupportRequestConfirmation: isSupportRequestShown,
  };
}

export default useDeactivateUser;
